import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ClientDataEntryDetailsLayer from "../components/ClientDataEntryDetailsLayer";

const ClientDataEntryDetailsPage = () => {
  return (
    <MasterLayout>
      <ClientDataEntryDetailsLayer />
    </MasterLayout>
  );
};

export default ClientDataEntryDetailsPage;
